// extracted by mini-css-extract-plugin
export default {"selectable":"user-selector_selectable__hvzo8"};